export const GONE_PATH_PREFIXES = ['/meaning', '/glossary-sitemaps'] as const;

export const GONE_EXPERT_PATHS = [
  '/expert/a-buddha-54245',
  '/expert/aashintaara-65775',
  '/expert/advisor-lunara-62112',
  '/expert/amara-veyra-e08cc',
  '/expert/angel-from-heaven-27fd7',
  '/expert/angel-gaia-6a895',
  '/expert/ariella-divine-eeaf3',
  '/expert/ask-urja-3aa80',
  '/expert/astro-jack-5fd70',
  '/expert/astro-wolf-6a4bc',
  '/expert/athena-james-8711e',
  '/expert/atum-be37d',
  '/expert/auralyne-1fc80',
  '/expert/aurelia-sage-f77cb',
  '/expert/buddy-56f99',
  '/expert/caitar-f98fe',
  '/expert/celeste-mirra-07d80',
  '/expert/cosmicdevi-ae4d2',
  '/expert/daniella-5a322',
  '/expert/dhumashree-6547a',
  '/expert/dionsian-7730c',
  '/expert/divine-flow-by-adah-2182a',
  '/expert/eclipse-c9781',
  '/expert/eliora-52c70',
  '/expert/emmasunlight-88b12',
  '/expert/esmeralda-nova-41576',
  '/expert/euma-enuma-bad69',
  '/expert/felicia-fox-17baa',
  '/expert/fortune-guide-archi-481e8',
  '/expert/gaurika-953b0',
  '/expert/guidance-by-san-1c9a2',
  '/expert/heaven-the-seer-b1a63',
  '/expert/hope-angel-11be9',
  '/expert/jasmine-74f54',
  '/expert/jazz-e69df',
  '/expert/joe-b9c10',
  '/expert/kaelestia-1891a',
  '/expert/kiyasu-294bc',
  '/expert/lady-elicia-stellar-5fe37',
  '/expert/lakshmi-75a78',
  '/expert/lia-6c893',
  '/expert/lucca-7b6d5',
  '/expert/luna-haven-9efad',
  '/expert/lupa-1930f',
  '/expert/maayan-e0e8d',
  '/expert/marie-21ec4',
  '/expert/markus-3b378',
  '/expert/miss-poo-11b7c',
  '/expert/miss-shira-f2c0a',
  '/expert/miss-skyller-fc98c',
  '/expert/miss-victoria-4cf10',
  '/expert/moon-priestess-ae8d7',
  '/expert/muhita-231d6',
  '/expert/mystic-jaa-c0f70',
  '/expert/mystic-veronica-c6561',
  '/expert/mysticmay-dfbca',
  '/expert/nadine-626a3',
  '/expert/nila-b5b84',
  '/expert/nova-heartfield-c599c',
  '/expert/physic-callie-whisper-of-oracle-274ad',
  '/expert/prikis-86ad5',
  '/expert/psychic-dr-bhawana-d7e9e',
  '/expert/psychic-jada-1fc24',
  '/expert/psychic-jade-ae790',
  '/expert/psychic-novi-193f8',
  '/expert/psychic-urvashi-60694',
  '/expert/psychic-vini-a6091',
  '/expert/psychic-yashvi-0045e',
  '/expert/rain-onyu-1ab0a',
  '/expert/rania-71ebf',
  '/expert/ranu-55f80',
  '/expert/rays-of-juno-de970',
  '/expert/rod-starman-89942',
  '/expert/roop-9f4cc',
  '/expert/rubys-universe-1441f',
  '/expert/sage-auriel-07d24',
  '/expert/sakhi-53ae5',
  '/expert/sara-midas-8d35f',
  '/expert/satella-58d63',
  '/expert/sean-adams-669a0',
  '/expert/selene-smith-78f32',
  '/expert/shik-163df',
  '/expert/simplyjohn-c7851',
  '/expert/sj-9e07b',
  '/expert/soul-friend-92ec8',
  '/expert/spiritual-essa-8ba12',
  '/expert/spiritual-gabriela-ce61c',
  '/expert/spiritual-lucian-67db7',
  '/expert/spiritual-mira-05bb9',
  '/expert/stellar-althea-573ca',
  '/expert/stellarvex-1c8c0',
  '/expert/stew-1b307',
  '/expert/sur-046e3',
  '/expert/sur-5d8ea',
  '/expert/surya-84460',
  '/expert/tani-33ef6',
  '/expert/tarot-mehar-7722c',
  '/expert/tarot-pj-9879a',
  '/expert/tarot-rachel-42506',
  '/expert/tarot-tulsyan-79dd3',
  '/expert/thelovealchemist-5d619',
  '/expert/tigretolove-c63a7',
  '/expert/tlc-empath-empress-cdf7f',
  '/expert/vera-d65a0',
  '/expert/witchy-rue-e8909',
  '/expert/yara-3be49',
  '/expert/zafar-aura-2ce4a',
  '/expert/zed-therapist-5d73b',
  '/expert/zenith-roy-31b0a',
] as const;

export const GONE_PATHS = [
  '/tarot-reading-near-me/new-orleans',
  '/tarot-reading-near-me/denver',
  '/tarot-reading-near-me/austin',
  '/tarot-reading-near-me/chicago',
  '/tarot-reading-near-me/las-vegas',
  '/tarot-reading-near-me/seattle',
  '/tarot-reading-near-me/portland',
  '/tarot-reading-near-me/san-diego',
  '/tarot-reading-near-me/houston',
  '/tarot-reading-near-me/san-antonio',
  '/tarot-reading-near-me/los-angeles',
  '/tarot-reading-near-me/atlanta',
  '/tarot-reading-near-me/san-francisco',
  '/tarot-reading-near-me/dallas',
  '/tarot-reading-near-me/minneapolis',
  '/tarot-reading-near-me/miami',
  '/tarot-reading-near-me/philadelphia',
  '/tarot-reading-near-me/salt-lake-city',
  '/tarot-reading-near-me/kansas-city',
  '/tarot-reading-near-me/salem',
  '/tarot-reading-near-me/boston',
  '/tarot-reading-near-me/milwaukee',
  '/tarot-reading-near-me/nashville',
  '/tarot-reading-near-me/tucson',
  '/tarot-reading-near-me/savannah',
  '/tarot-reading-near-me/new-york',
  '/tarot-reading-near-me/pittsburgh',
  '/tarot-reading-near-me/tulsa',
  '/tarot-reading-near-me/cincinnati',
  '/tarot-reading-near-me/orlando',
  '/tarot-reading-near-me/tampa',
  '/tarot-reading-near-me/phoenix',
  '/tarot-reading-near-me/sacramento',
  '/tarot-reading-near-me/fort-worth',
  '/tarot-reading-near-me/colorado-springs',
  '/tarot-reading-near-me/el-paso',
  '/tarot-reading-near-me/bakersfield',
  '/tarot-reading-near-me/indianapolis',
  '/tarot-reading-near-me/omaha',
  '/tarot-reading-near-me/birmingham',
  '/tarot-reading-near-me/albuquerque',
  '/tarot-reading-near-me/tallahassee',
  '/tarot-reading-near-me/chattanooga',
  '/tarot-reading-near-me/fort-lauderdale',
  '/tarot-reading-near-me/michigan',
  '/tarot-reading-near-me/manchester',
  '/tarot-reading-near-me/richmond',
  '/psychic-near-me/alabama',
  '/psychic-near-me/albuquerque',
  '/psychic-near-me/amarillo',
  '/psychic-near-me/ann-arbor',
  '/psychic-near-me/annapolis',
  '/psychic-near-me/arizona',
  '/psychic-near-me/arlington',
  '/psychic-near-me/asheville',
  '/psychic-near-me/atlanta',
  '/psychic-near-me/atlantic-city',
  '/psychic-near-me/austin',
  '/psychic-near-me/bakersfield',
  '/psychic-near-me/baltimore',
  '/psychic-near-me/baton-rouge',
  '/psychic-near-me/bedford',
  '/psychic-near-me/berkeley',
  '/psychic-near-me/birmingham',
  '/psychic-near-me/boca-raton',
  '/psychic-near-me/boise',
  '/psychic-near-me/boston',
  '/psychic-near-me/boulder',
  '/psychic-near-me/boynton-beach',
  '/psychic-near-me/bozeman',
  '/psychic-near-me/brentwood',
  '/psychic-near-me/bristol',
  '/psychic-near-me/brooklyn',
  '/psychic-near-me/california',
  '/psychic-near-me/cambridge',
  '/psychic-near-me/cape-coral',
  '/psychic-near-me/chandler',
  '/psychic-near-me/charleston',
  '/psychic-near-me/charlotte',
  '/psychic-near-me/chattanooga',
  '/psychic-near-me/chesterfield',
  '/psychic-near-me/chicago',
  '/psychic-near-me/cincinnati',
  '/psychic-near-me/cleveland',
  '/psychic-near-me/colorado-springs',
  '/psychic-near-me/colorado',
  '/psychic-near-me/columbus',
  '/psychic-near-me/connecticut',
  '/psychic-near-me/corpus-christi',
  '/psychic-near-me/dallas',
  '/psychic-near-me/davis',
  '/psychic-near-me/dayton',
  '/psychic-near-me/daytona-beach',
  '/psychic-near-me/delaware',
  '/psychic-near-me/delray-beach',
  '/psychic-near-me/denver',
  '/psychic-near-me/des-moines',
  '/psychic-near-me/detroit',
  '/psychic-near-me/dover',
  '/psychic-near-me/el-paso',
  '/psychic-near-me/elizabeth',
  '/psychic-near-me/florida',
  '/psychic-near-me/fort-collins',
  '/psychic-near-me/fort-lauderdale',
  '/psychic-near-me/fort-myers',
  '/psychic-near-me/fort-worth',
  '/psychic-near-me/fremont',
  '/psychic-near-me/fresno',
  '/psychic-near-me/gainesville',
  '/psychic-near-me/georgia',
  '/psychic-near-me/grand-rapids',
  '/psychic-near-me/hamilton',
  '/psychic-near-me/haverhill',
  '/psychic-near-me/hawaii',
  '/psychic-near-me/hoboken',
  '/psychic-near-me/hollywood',
  '/psychic-near-me/honolulu',
  '/psychic-near-me/houston',
  '/psychic-near-me/huntington-beach',
  '/psychic-near-me/idaho-falls',
  '/psychic-near-me/idaho',
  '/psychic-near-me/illinois',
  '/psychic-near-me/indiana',
  '/psychic-near-me/indianapolis',
  '/psychic-near-me/iowa-city',
  '/psychic-near-me/irvine',
  '/psychic-near-me/jacksonville',
  '/psychic-near-me/jersey-city',
  '/psychic-near-me/kansas-city',
  '/psychic-near-me/lancaster',
  '/psychic-near-me/las-vegas',
  '/psychic-near-me/lincoln',
  '/psychic-near-me/long-beach',
  '/psychic-near-me/los-angeles',
  '/psychic-near-me/louisiana',
  '/psychic-near-me/louisville',
  '/psychic-near-me/madison',
  '/psychic-near-me/maine',
  '/psychic-near-me/manchester',
  '/psychic-near-me/manhattan',
  '/psychic-near-me/maryland',
  '/psychic-near-me/massachusetts',
  '/psychic-near-me/melbourne',
  '/psychic-near-me/memphis',
  '/psychic-near-me/mentor',
  '/psychic-near-me/miami-beach',
  '/psychic-near-me/miami',
  '/psychic-near-me/michigan',
  '/psychic-near-me/milwaukee',
  '/psychic-near-me/minneapolis',
  '/psychic-near-me/minnesota',
  '/psychic-near-me/mission-viejo',
  '/psychic-near-me/mississippi',
  '/psychic-near-me/modesto',
  '/psychic-near-me/nashville',
  '/psychic-near-me/nevada',
  '/psychic-near-me/new-hampshire',
  '/psychic-near-me/new-jersey',
  '/psychic-near-me/new-orleans',
  '/psychic-near-me/new-york',
  '/psychic-near-me/newport-beach',
  '/psychic-near-me/north-carolina',
  '/psychic-near-me/norwich',
  '/psychic-near-me/oakland',
  '/psychic-near-me/oceanside',
  '/psychic-near-me/ohio',
  '/psychic-near-me/oklahoma-city',
  '/psychic-near-me/omaha',
  '/psychic-near-me/oregon',
  '/psychic-near-me/orlando',
  '/psychic-near-me/palm-springs',
  '/psychic-near-me/palo-alto',
  '/psychic-near-me/pasadena',
  '/psychic-near-me/pennsylvania',
  '/psychic-near-me/pensacola',
  '/psychic-near-me/philadelphia',
  '/psychic-near-me/phoenix',
  '/psychic-near-me/pittsburgh',
  '/psychic-near-me/plano',
  '/psychic-near-me/plymouth',
  '/psychic-near-me/portland',
  '/psychic-near-me/portsmouth',
  '/psychic-near-me/queens',
  '/psychic-near-me/raleigh',
  '/psychic-near-me/reno',
  '/psychic-near-me/rhode-island',
  '/psychic-near-me/richmond',
  '/psychic-near-me/riverside',
  '/psychic-near-me/rochester',
  '/psychic-near-me/royal-oak',
  '/psychic-near-me/sacramento',
  '/psychic-near-me/salem',
  '/psychic-near-me/salt-lake-city',
  '/psychic-near-me/san-antonio',
  '/psychic-near-me/san-diego',
  '/psychic-near-me/san-francisco',
  '/psychic-near-me/san-jose',
  '/psychic-near-me/santa-barbara',
  '/psychic-near-me/santa-cruz',
  '/psychic-near-me/santa-fe',
  '/psychic-near-me/santa-monica',
  '/psychic-near-me/santa-rosa',
  '/psychic-near-me/sarasota',
  '/psychic-near-me/savannah',
  '/psychic-near-me/scottsdale',
  '/psychic-near-me/seattle',
  '/psychic-near-me/shreveport',
  '/psychic-near-me/south-carolina',
  '/psychic-near-me/spokane',
  '/psychic-near-me/st-louis',
  '/psychic-near-me/staten-island',
  '/psychic-near-me/stockton',
  '/psychic-near-me/tacoma',
  '/psychic-near-me/tallahassee',
  '/psychic-near-me/tampa',
  '/psychic-near-me/taylor',
  '/psychic-near-me/temecula',
  '/psychic-near-me/temple',
  '/psychic-near-me/tennessee',
  '/psychic-near-me/texas',
  '/psychic-near-me/tucson',
  '/psychic-near-me/tulsa',
  '/psychic-near-me/tyler',
  '/psychic-near-me/utah',
  '/psychic-near-me/vancouver',
  '/psychic-near-me/vermont',
  '/psychic-near-me/virginia-beach',
  '/psychic-near-me/virginia',
  '/psychic-near-me/washington',
  '/psychic-near-me/wellington',
  '/psychic-near-me/west-covina',
  '/psychic-near-me/west-palm-beach',
  '/psychic-near-me/worcester',
  '/psychic-near-me/york',
  '/advisors/arturo',
  '/advisors/esmeralda-moonstone',
  '/advisors/lois-solomon',
  '/advisors/mystic-aurora',
  '/advisors/mystic-lea',
  '/advisors/phobos',
  '/advisors/takara',
  '/advisors/astro-alexis',
  '/advisors/bea-insightful',
  '/advisors/bella-8',
  '/advisors/bellatrix',
  '/advisors/belvedere',
  '/advisors/cassandra',
  '/advisors/charmed-spirit-mekelle',
  '/advisors/dana',
  '/advisors/davina',
  '/advisors/elthia',
  '/advisors/hephestus',
  '/advisors/kalea',
  '/advisors/katarina',
  '/advisors/lady-alana',
  '/advisors/lady-aurelia',
  '/advisors/lady-laura',
  '/advisors/lady-rosa',
  '/advisors/mama-dilara',
  '/advisors/master-erling',
  '/advisors/maya',
  '/advisors/medison-magician',
  '/advisors/miss-ayana',
  '/advisors/oracle-laurance',
  '/advisors/orion',
  '/advisors/pearl',
  '/advisors/psychic-virginia',
  '/advisors/pure-energy-mohana',
  '/advisors/reverie',
  '/advisors/sirius',
  '/advisors/solange',
  '/advisors/taira-insight',
  '/advisors/tarot-master-morgana',
  ...GONE_EXPERT_PATHS,
] as const;
